import React from 'react'

const ThumbsUpIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.316 15.311">
      <g data-name="thumb-up-svgrepo-com (1)">
        <path
          data-name="Path 922"
          d="M8.3 17.406H5.487a.987.987 0 0 1-.987-.987v-4.932a.987.987 0 0 1 .987-.987H8.3a.148.148 0 0 1 .148.148v6.61a.148.148 0 0 1-.148.148z"
          transform="translate(-3.75 -3.831)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
        <path
          data-name="Path 923"
          d="m8.5 11.406 1.869-3.738a.986.986 0 0 0 .1-.441v-1.74a.987.987 0 0 1 .991-.987h0a1.973 1.973 0 0 1 1.973 1.973v3.946"
          transform="translate(-3.804 -3.75)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
        <path
          data-name="Path 924"
          d="M11.46 10.5h5.916a.986.986 0 0 1 .947 1.262L16.6 17.681a.986.986 0 0 1-.947.711h-3.785a.987.987 0 0 1-.7-.289l-.409-.409a.987.987 0 0 0-.7-.289H8.5"
          transform="translate(-3.804 -3.831)"
          style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        />
      </g>
    </svg>
  )
}

export default ThumbsUpIcon
